var map = {
	"./ExclamationCircleFilled.svg": 2410,
	"./G.svg": 74276,
	"./O.svg": 87336,
	"./R.svg": 40241,
	"./W.svg": 54455,
	"./ai-brain.svg": 42646,
	"./airplane.svg": 66994,
	"./bell.svg": 83227,
	"./brain.svg": 62302,
	"./calendar.svg": 12420,
	"./check-green.svg": 80349,
	"./check.svg": 74270,
	"./close.svg": 35751,
	"./coming-soon.svg": 58375,
	"./delete.svg": 89484,
	"./distance.svg": 96857,
	"./edit.svg": 48987,
	"./face-emoji-nomal.svg": 94225,
	"./face-emoji-sad.svg": 77618,
	"./face-emoji-smiley.svg": 38463,
	"./flag.svg": 83248,
	"./heart.svg": 48506,
	"./limited-time-free.svg": 41552,
	"./lock.svg": 6160,
	"./minus-sign.svg": 60677,
	"./pause.svg": 11687,
	"./position.svg": 42013,
	"./question-mark.svg": 30278,
	"./recording.svg": 90039,
	"./refresh.svg": 26479,
	"./sonic.svg": 37640,
	"./switch.svg": 1419,
	"./technique.svg": 2588,
	"./titleFlag.svg": 91135,
	"./triangle-right.svg": 73716,
	"./triangle.svg": 69394,
	"./triangular-arrow.svg": 96566,
	"./unhappy.svg": 67862,
	"./upload.svg": 4950,
	"./warn.svg": 21309,
	"./water-drops-add.svg": 29059,
	"./water-drops.svg": 27133,
	"./write.svg": 60264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32228;